import React from "react";

const Trash = ({ style }) => (
  <svg
    width="1.142rem"
    height="1.1rem"
    viewBox="0 0 24 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.4393 5.32896C18.9287 5.17885 17.4181 5.06626 15.8982 4.98182V4.97243L15.6918 3.75273C15.5511 2.88955 15.3446 1.59479 13.1492 1.59479H10.691C8.50491 1.59479 8.2985 2.83326 8.14838 3.74335L7.95135 4.94429C7.07879 5.00058 6.20623 5.05688 5.33367 5.14132L3.41968 5.32896C3.02562 5.36649 2.74415 5.71364 2.78167 6.09832C2.8192 6.48299 3.15697 6.76446 3.55103 6.72693L5.46503 6.53929C10.3814 6.05141 15.3353 6.23905 20.3079 6.73632C20.3361 6.73632 20.3548 6.73632 20.383 6.73632C20.7395 6.73632 21.0491 6.46423 21.0866 6.09832C21.1148 5.71364 20.8333 5.36649 20.4393 5.32896Z"
      fill="#D93333"
    />
    <path
      d="M18.713 8.05878C18.4878 7.82422 18.1782 7.69287 17.8592 7.69287H5.99988C5.68088 7.69287 5.36188 7.82422 5.14609 8.05878C4.93029 8.29334 4.80832 8.61234 4.82709 8.94072L5.40879 18.567C5.512 19.9931 5.64335 21.7758 8.91779 21.7758H14.9413C18.2157 21.7758 18.3471 20.0025 18.4503 18.567L19.032 8.95011C19.0507 8.61234 18.9288 8.29334 18.713 8.05878Z"
      fill="#D93333"
    />
  </svg>
);
export default Trash;
